/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Book_BodyInputs */

const en_price_page_book_body = /** @type {(inputs: Price_Page_Book_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick a service and a time, see the price and pay in the app. The money goes straight to the specialist.`)
};

const pl_price_page_book_body = /** @type {(inputs: Price_Page_Book_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierasz usługę i godzinę, widzisz cenę i płacisz w aplikacji. Pieniądze trafiają prosto do specjalisty.`)
};

/**
* | output |
* | --- |
* | "Pick a service and a time, see the price and pay in the app. The money goes straight to the specialist." |
*
* @param {Price_Page_Book_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_book_body = /** @type {((inputs?: Price_Page_Book_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Book_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_book_body(inputs)
	return en_price_page_book_body(inputs)
});